import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const BannerSection = ({
  title,
  highlightedText,
  description,
  buttonText,
  buttonLink,
  backgroundColor = "var(--primary-color)",
  variant = "dark", // 'dark' or 'light'
}) => {
  // Determine text colors based on variant
  const isDark = variant === "dark";
  const titleColor = isDark ? "text-white" : "text-gray-800";
  const descriptionColor = isDark ? "text-gray-200" : "text-gray-600";
  const highlightColor = "var(--secondary-color)";

  return (
    <section style={{ backgroundColor }} className="py-16 md:py-20 lg:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* Title */}
          <h2 className={`font-bold ${titleColor} mb-6 leading-tight`}>
            {title}{" "}
            <span style={{ color: highlightColor }}>{highlightedText}</span>
          </h2>

          {/* Description */}
          <p
            className={`   ${descriptionColor} mb-8 leading-relaxed max-w-3xl mx-auto`}
          >
            {description}
          </p>

          {/* Button */}
          {buttonText && buttonLink && (
            <Link
              to={buttonLink}
              className="inline-block btn btn-white"
            >
              {buttonText}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

BannerSection.propTypes = {
  title: PropTypes.string.isRequired,
  highlightedText: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  buttonLink: PropTypes.string,

  variant: PropTypes.oneOf(["dark", "light"]),
};

export default BannerSection;
